import AdminUserDecorator from "./AdminUserDecorator";
import AdminUserFullDecorator from "./AdminUserFullDecorator";
import AgentCooperationDecorator from "./AgentCooperationDecorator";
import AgentCooperationFullDecorator from "./AgentCooperationFullDecorator";
import AgentProductDealDecorator from "./AgentProductDealDecorator";
import AgentDealPricingDecorator from "./AgentDealPricingDecorator";
import AttachmentDecorator from "./AttachmentDecorator";
import CompanyDecorator from "./CompanyDecorator";
import CompanyFullDecorator from "./CompanyFullDecorator";
import CompanyMemberDecorator from "./CompanyMemberDecorator";
import CompanyMemberFullDecorator from "./CompanyMemberFullDecorator";
import CouponCodeDecorator from "./CouponCodeDecorator";
import CustomerDecorator from "./CustomerDecorator";
import CustomerFullDecorator from "./CustomerFullDecorator";
import FacilityDecorator from "./FacilityDecorator";
import OrderCustomerParticipantDecorator from "./OrderCustomerParticipantDecorator";
import OrderDecorator from "./OrderDecorator";
import OrderedProductOrderFieldDecorator from "./OrderedProductOrderFieldDecorator";
import OrderedProductPricelistItemDecorator from "./OrderedProductPricelistItemDecorator";
import OrderFullDecorator from "./OrderFullDecorator";
import OrderInstallmentDecorator from "./OrderInstallmentDecorator";
import OrderItemDecorator from "./OrderItemDecorator";
import OrderTransferDecorator from "./OrderTransferDecorator";
import PaymentProfileDecorator from "./PaymentProfileDecorator";
import PaymentProfileInstallmentDecorator from "./PaymentProfileInstallmentDecorator";
import PaymentProfileProductAttachmentDecorator from "./PaymentProfileProductAttachmentDecorator";
import PricingPlanDecorator from "./PricingPlanDecorator";
import ProductDecorator from "./ProductDecorator";
import ProductFullDecorator from "./ProductFullDecorator";
import ProductLocationDecorator from "./ProductLocationDecorator";
import ProductOrderFieldDecorator from "./ProductOrderFieldDecorator";
import ProductOrderFieldListOptionDecorator from "./ProductOrderFieldListOptionDecorator";
import ProductPickupPointDecorator from "./ProductPickupPointDecorator";
import ProductPricelistItemDecorator from "./ProductPricelistItemDecorator";
import ProductScheduleDecorator from "./ProductScheduleDecorator";
import ProductScheduleSlotDecorator from "./ProductScheduleSlotDecorator";
import ProductScheduleSlotFullDecorator from "./ProductScheduleSlotFullDecorator";
import ProductVariantDecorator from "./ProductVariantDecorator";
import ProductVariantFullDecorator from "./ProductVariantFullDecorator";
import ReviewDecorator from "./ReviewDecorator";

export {
  AdminUserDecorator,
  AdminUserFullDecorator,
  AgentCooperationDecorator,
  AgentCooperationFullDecorator,
  AgentProductDealDecorator,
  AgentDealPricingDecorator,
  AttachmentDecorator,
  CompanyDecorator,
  CompanyFullDecorator,
  CompanyMemberDecorator,
  CompanyMemberFullDecorator,
  CouponCodeDecorator,
  CustomerDecorator,
  CustomerFullDecorator,
  FacilityDecorator,
  OrderCustomerParticipantDecorator,
  OrderDecorator,
  OrderedProductOrderFieldDecorator,
  OrderedProductPricelistItemDecorator,
  OrderFullDecorator,
  OrderInstallmentDecorator,
  OrderItemDecorator,
  OrderTransferDecorator,
  PaymentProfileDecorator,
  PaymentProfileInstallmentDecorator,
  PaymentProfileProductAttachmentDecorator,
  PricingPlanDecorator,
  ProductDecorator,
  ProductFullDecorator,
  ProductLocationDecorator,
  ProductOrderFieldDecorator,
  ProductOrderFieldListOptionDecorator,
  ProductPickupPointDecorator,
  ProductPricelistItemDecorator,
  ProductScheduleDecorator,
  ProductScheduleSlotDecorator,
  ProductScheduleSlotFullDecorator,
  ProductVariantDecorator,
  ProductVariantFullDecorator,
  ReviewDecorator,
};



// WEBPACK FOOTER //
// ./src/lib/decorators/index.js